<div class="line-color-div">

  @if (params.data['lineColourCode'] !== 0 && lineColourObj?.[value]) {
    <p
      [ngStyle]="{'width':width-40 + 'px'}"
      class="line-color-desc">
      {{value}} - {{lineColourObj?.[value]?.description}}
    </p>
  } @else {
    @if (params.data['lineColourCode'] === 0 || params.data['lineColourCode'] === '0' ) {
      <p
        [ngStyle]="{'width': width-40 + 'px'}"
        class="line-color-desc">
        0 - No Line Colour
      </p>
    } @else {
      <p [ngStyle]="{'width': width-40 + 'px'}" class="line-color-desc does-not-exist">
        the selected line colour does not exist
      </p>
    }
  }



  @if (params.data.originalValue[params.colDef.field].value !== value && (params.context?.isStockManager || !params.data.disabled)) {
    <app-icon-backspace-outline
      (click)="onUndoChangesClick()"
      [tooltip]="'Previous Value = ' +params.data.originalValue[params.colDef.field].value"
      class="backspace">
    </app-icon-backspace-outline>
  }

</div>

